import {FilterEnum} from 'Agent/Accounts/ducks/account';

export enum LineOfBusiness {
  Agent = 1,
  BOSTools = 4,
  Messaging = 5,
  Quoting = 9
}

export const LinesOfBusiness: FilterEnum[] = [
  {
    name: 'Agents',
    value: 'agent',
  },
  {
    name: 'BOS Tools',
    value: 'bostools',
  },
  {
    name: 'Messaging',
    value: 'messaging',
  },
  {
    name: 'Quoting',
    value: 'quoting',
  },
];

export type LineOfBusinessValue = 'agent' | 'bostools' | 'messaging' | 'quoting';
